import type { FlightPlaces } from "@/types/flights";
import { Plane } from "lucide-react";
import { useTheme } from "next-themes";
import { MapMarkerIcon } from "../../Icons";
import { useTranslations } from "next-intl";

export const DestinationFieldDropdown = ({
  options,
  onClick,
}: {
  options: FlightPlaces[];
  onClick: (flight: FlightPlaces) => void;
}) => {
  const t = useTranslations("Other");
  const { resolvedTheme } = useTheme();

  return (
    <ul className="rounded-2xl bg-lightwhite dark:bg-sleap-gray-950 dark:text-white absolute left-0 top-full mt-2 min-w-56 z-10 shadow-[0_23px_45px_-10px_rgba(0,0,0,0.25)]">
      {options.map(({ name, iataCode, type, country }, index) => (
        <li
          className="group"
          key={index}
          onClick={() => onClick({ name, iataCode })}
        >
          <button className="flex items-center gap-3 px-4 py-3 w-full justify-start hover:bg-sleap-flight-blue-50 rounded-none group-first:rounded-t-2xl group-last:rounded-b-2xl dark:hover:bg-sleap-fern-100 group ">
            <span className="block">
              {type === "city" ? (
                <MapMarkerIcon
                  color={resolvedTheme === "dark" ? "offWhite" : "lightblack"}
                />
              ) : (
                <Plane />
              )}
            </span>
            <div className="flex flex-col">
              <h3 className="mb-0 text-base font-semibold font-inter text-sleap-gray-950 text-left dark:text-lightwhite">
                {name} {type === "city" ? `(${t("any")})` : `(${iataCode})`}
              </h3>
              <span className="text-sm font-inter text-left text-sleap-gray-500 dark:group-hover:text-sleap-flight-blue-200 group-hover:text-sleap-flight-blue-100">
                {country}
              </span>
            </div>
          </button>
        </li>
      ))}
    </ul>
  );
};
